import raw from "raw.macro";
import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router-dom";

import Breadcrumbs from "../../component/breadcrumbs";
import CustomHelmet from "../../component/CustomHelmet";
import Intro from "../../component/Intro";
import BaseContainer from "../../component/layout/base-container";
import TeacherInfoForm from "../../component/TecherInfoForm";
import { components } from "../../lib/markdownComponentMapping";

export default function AddTeacherInfo({ user, updateFunction }) {
  const navigate = useNavigate();

  updateFunction();

  const infotext_erste_anmeldung = raw(
    "../../textblocke/lehrerinnen/erste-anmeldung.md"
  );

  useEffect(() => {
    if (user && user.teacher) navigate("/dashboard");
  }, [user, navigate]);

  return (
    <>
      <CustomHelmet pageTitle="Registrierung" />
      <Breadcrumbs
        listItems={[
          { name: "Home", url: "/" },
          { name: "Umfragen", url: "/dashboard" },
          { name: "Registrierung Lehrperson", url: "/dashboard/signup" },
        ]}
      />
      <BaseContainer>
        <Intro title={"Registrierung"}>
          <ReactMarkdown components={components} className="Intro--text">
            {infotext_erste_anmeldung}
          </ReactMarkdown>
        </Intro>
        <TeacherInfoForm
          user={user}
          onSubmit={async () => {
            await updateFunction();
            navigate("/dashboard");
          }}
        />
      </BaseContainer>
    </>
  );
}
